import { render, staticRenderFns } from "./RuleValueInput.vue?vue&type=template&id=0651254f&"
import script from "./RuleValueInput.vue?vue&type=script&lang=js&"
export * from "./RuleValueInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports